import { render, staticRenderFns } from "./DetalleUsuarioDireccion.vue?vue&type=template&id=0132a91e&"
import script from "./DetalleUsuarioDireccion.vue?vue&type=script&lang=js&"
export * from "./DetalleUsuarioDireccion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports